module.exports = __webpack_public_path__ + "img/5.407a04ba.png";